import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdAttachment: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 14 19" fill="none" {...props}>
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M2.43653 16.3399C1.09303 15.4598 0.59162 13.5812 1.31881 12.1521L5.74416 3.45558C6.71375 1.55017 8.95995 0.95466 10.7513 2.12809C12.5426 3.30152 13.2112 5.80635 12.2416 7.71176L7.81624 16.4083L7.00406 15.8763L11.4294 7.17974C12.1566 5.75068 11.6552 3.87205 10.3117 2.99198C8.96818 2.11191 7.28353 2.55855 6.55634 3.98761L2.13099 12.6842C1.6462 13.6369 1.98047 14.8893 2.87614 15.476C3.77181 16.0627 4.89491 15.765 5.3797 14.8122L8.92584 7.84349C9.16824 7.36713 9.0011 6.74092 8.55327 6.44757C8.10543 6.15421 7.54388 6.30309 7.30149 6.77944L3.75535 13.7482L2.94317 13.2162L6.48931 6.24742C6.9741 5.29472 8.0972 4.99696 8.99287 5.58367C9.88854 6.17039 10.2228 7.4228 9.73802 8.37551L6.19188 15.3443C5.46469 16.7733 3.78004 17.22 2.43653 16.3399Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdAttachment;
